import { api_without_cancellation } from "../../../api/api";

const addEditLoanApi = async (payload) => {
  const { data } = await api_without_cancellation.post(
    "/api/caseloan-page/add-case-loans/",
    payload
  );

  return data;
};

export default addEditLoanApi;

export const EditLoanApi = async (payload) => {
  const { data } = await api_without_cancellation.patch(
    "/api/caseloan-page/edit-case-loan/",
    payload
  );

  return data;
};
